import {Component, Input, OnInit} from '@angular/core';
import {ServiceSubject} from '../../../Models/ServiceSubject';
import {OrderDownlineTreeviewEventParser, TreeviewConfig, TreeviewEventParser, TreeviewItem} from '@paymate-software/ngx-treeview';
import {Model} from '../../../Models/Model';
import {ServiceSubjectService} from '../../../Services/service-subject.service';
import {CollectionService} from '../../../Services/collection.service';
import {Router} from '@angular/router';
import {ProductTreeviewConfig} from '../../supplier/view-supplier/view-supplier.component';

@Component({
  selector: 'app-service-subject-products',
  templateUrl: './service-subject-products.component.html',
  styleUrls: ['./service-subject-products.component.scss'],
  providers: [
    {provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser},
    {provide: TreeviewConfig, useClass: ProductTreeviewConfig}
  ]
})
export class ServiceSubjectProductsComponent implements OnInit {
  @Input() serviceSubject: ServiceSubject;
  public items = [];
  public isLoading = true;
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    maxHeight: 400
  });
  public selectedProducts = [];

  constructor(
    private subjectService: ServiceSubjectService,
    private collectionService: CollectionService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.collectionService.getProductOptions().subscribe((res) => {
      res.data.forEach((collection) => {
        const children = [];
        collection.models.forEach((model: Model) => {
          const styles = [];
          if (model.styles.length > 0) {
            model.styles.forEach((modelStyle) => {
              const products = [];
              model.products.forEach((product) => {
                const checkItem = this.serviceSubject.products.findIndex(x => x.id === product.id) !== -1;
                products.push({
                  text: product.name || "", value: product.id, checked: checkItem
                });
                if (checkItem) {
                  this.selectedProducts.push(product.id);
                }
              });
              if (products.length > 0) {
                styles.push({
                  text: modelStyle.name || "", value: modelStyle.id, children: products
                });
              }
            });
            if (styles.length > 0) {
              children.push({
                text: model.name || "", value: model.id, collapsed: true, children: styles
              });
            }
          } else {
            const products = [];
            model.products.forEach((product) => {
              const checkItem = this.serviceSubject.products.findIndex(x => x.id === product.id) !== -1;
              products.push({
                text: product.name || "", value: product.id, checked: checkItem
              });
              if (checkItem) {
                this.selectedProducts.push(product.id);
              }
            });
            if (products.length > 0) {
              children.push({
                text: model.name, value: model.id, collapsed: true, children: products
              });
            }
          }
        });
        if (children.length > 0) {
          const collectionItem = new TreeviewItem({text: collection.name, value: collection.id, collapsed: true, children: children});
          this.items.push(collectionItem);
        }
      });
      this.isLoading = false;
    });
  }

  saveProducts() {
    const id = this.serviceSubject?.id;
    if (id == null) {
      return;
    }
    this.subjectService.saveProducts(
      {products: this.selectedProducts}, id
    ).subscribe(() => this.navigatedToOverview());
  }

  navigatedToOverview() {
    this.router.navigateByUrl('/back-office/service/subject/overview');
  }

  onSelectedChange(items: { item: { value?: number; disabled?: boolean } }[]) {
    const ids: number[] = [];
    (items || []).forEach((downlineItem) => {
      const item = downlineItem.item;
      if (item && !item.disabled && item.value != null) {
        ids.push(item.value);
      }
    });
    this.selectedProducts = [...new Set(ids)];
  }
}
